import { FunctionComponent } from 'react';
import styles from './Spinner.module.scss';

interface SpinnerProps {
    size?: number;
    color?: string;
}

export const Spinner: FunctionComponent<SpinnerProps> = props => {
    const spinnerStyle = {
        width: props.size ?? 48,
        height: props.size ?? 48,
        fontSize: props.size ?? 48,
        color: props.color
    };

    return (
        <div
            className={styles.spinner}
            style={spinnerStyle}
        ></div>
    );
};

export default Spinner;
